module.exports = __webpack_public_path__ + "static/media/kubernetes.b0960998.svg";